import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Button, Space, Spin, Typography, notification } from 'antd';
import { SendOutlined } from '@ant-design/icons';
import { CampaignForm } from './CampaignForm';
import { SendCampaignModal } from './SendCampaignModal';
import { campaignsApi } from '../services/catalogServiceAPI/campaignsProxy';

export function EditCampaign() {
    const { id } = useParams();
    const history = useHistory();
    const [campaign, setCampaign] = useState(null);
    const [loading, setLoading] = useState(true);
    const [sending, setSending] = useState(false);

    useEffect(() => {
        campaignsApi.get(id)
            .then(setCampaign)
            .catch((e) => notification.error({ message: 'Failed to load campaign', description: e.message }))
            .finally(() => setLoading(false));
    }, [id]);

    const onSaved = () => {
        notification.success({ message: 'Campaign saved' });
        history.push('/campaigns');
    };

    if (loading) return <div style={{ padding: 32 }}><Spin /></div>;
    if (!campaign) return <div style={{ padding: 32 }}><Typography.Text type="secondary">Campaign not found.</Typography.Text></div>;

    return (
        <div style={{ padding: '24px 32px' }}>
            <Space align="center" style={{ marginBottom: 16, width: '100%', justifyContent: 'space-between' }}>
                <Typography.Title level={3} style={{ margin: 0 }}>Edit campaign</Typography.Title>
                <Button icon={<SendOutlined />} onClick={() => setSending(true)}>Send as notification</Button>
            </Space>
            <CampaignForm campaign={campaign} campaignId={id} onSaved={onSaved} submitLabel="Save campaign" />
            {sending && <SendCampaignModal campaign={campaign} onClose={() => setSending(false)} />}
        </div>
    );
}
